import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {environment} from './environments/environment';
import {hmrBootstrap} from './hmr';

import * as webpack from 'webpack';
import {AppBrowserModule} from './app/app.browser.module';

if (environment.production) {
    enableProdMode();
}

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppBrowserModule);


if (module['hot']) {
    console.log('Starting with HMR ...');
    hmrBootstrap(module, bootstrap);
} else {
    bootstrap()
        .catch(err => console.log(err));
}


